import { render, staticRenderFns } from "./OrderLogisticsUser.vue?vue&type=template&id=4e19ba3c&scoped=true"
import script from "./OrderLogisticsUser.vue?vue&type=script&lang=js"
export * from "./OrderLogisticsUser.vue?vue&type=script&lang=js"
import style0 from "./OrderLogisticsUser.vue?vue&type=style&index=0&id=4e19ba3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19ba3c",
  null
  
)

export default component.exports